import { useField, FieldHookConfig } from "formik";
import { styled } from "@mui/material";
import { FC, ReactElement } from "react";
import { ErrorMessage, InputWrapper, Label, Span, StyledImg, StyledNumber } from "./FormInput";

interface ComponentProps {
    label?: string;
    type?: string;
    marginRight?: string;
    width?: string;
  
    defaultValue?: any;
    icon?: string;
  }

const CustomTextArea: FC<ComponentProps & FieldHookConfig<string> & any> = (
    props
  ): ReactElement => {
    const [field, meta] = useField(props);
    return (

        <InputWrapper aria-label="form input container">
      <Label htmlFor={props.id || props.name}>{props.label}</Label>
      {props.type === "tel" ? (
        <StyledNumber
          {...props}
          {...field}
          type={props.type || "text"}
          allowNegative={
            (props.type === "tel" || props.type === "date") && false
          }
          allowLeadingZeros={
            (props.type === "tel" || props.type === "date") && true
          }
        />
      ) : (
        <StyledTextArea
          {...props}
          {...field}
          type={props.type}
          placeholder={props.placeholder}
        />
      )}
      {props.icon ? <StyledImg src={`${props.icon}`} /> : undefined}
      {
        /**validation error message */
        meta.touched && meta.error ? (
          <ErrorMessage>
            <Span>&#42;</Span>
            {meta.error}
          </ErrorMessage>
        ) : null
      }
    </InputWrapper>

        // <>
        //     <label htmlFor={props.id || props.name}>{label}</label>
        //     <textarea className="text-area" {...field} {...props} />
        //     {meta.touched && meta.error ? (
        //         <div className="error">{meta.error}</div>
        //     ) : null}
        // </>
    );
  };
  export default CustomTextArea;


  export const StyledTextArea = styled("textarea")<ComponentProps>`
  flex: 1 1 100%;
  padding: 1.4rem 2.4rem;
  font-size: 1.5rem;
  height: 3.6rem;
  box-shadow: 0 0.7rem 0.9rem -3rem rgba(70, 70, 70, 0.06);
  color: var(--color-black-default);
  transition: all 0.5s ease-out;
  transform-origin: top left;
//   background: #f6fbf3;
  border: 0.1rem solid #E1E1E1;
  border-radius: 0.4rem;

  &:focus {
    outline: none;
    border: 0.1rem solid var(--color-primary);
  }

  &:disabled {
    background-color: #dadada;
  }
`;